import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-516754d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_5 = { class: "d-flex align-items-center mb-4" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "card p-3 mb-4" }
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "table-responsive mb-4"
}
const _hoisted_14 = { class: "table table-sm" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "detailField" }
const _hoisted_18 = { class: "fw_600" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "detailField" }
const _hoisted_21 = { class: "fw_600" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "detailField" }
const _hoisted_24 = { class: "fw_600" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "detailField" }
const _hoisted_27 = { class: "fw_600" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "detailField" }
const _hoisted_30 = { class: "fw_600" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "detailField" }
const _hoisted_33 = { class: "fw_600" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "detailField" }
const _hoisted_36 = { class: "fw_600" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_38 = {
  key: 1,
  class: "row"
}
const _hoisted_39 = { class: "col-md-3" }
const _hoisted_40 = { class: "detailField" }
const _hoisted_41 = { class: "fw_600" }
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = { class: "detailField" }
const _hoisted_44 = { class: "fw_600" }
const _hoisted_45 = { class: "col-md-3" }
const _hoisted_46 = { class: "detailField" }
const _hoisted_47 = { class: "fw_600" }
const _hoisted_48 = { class: "col-md-3" }
const _hoisted_49 = { class: "detailField" }
const _hoisted_50 = { class: "fw_600" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_52 = { class: "registryGroupTitle" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "detailField" }
const _hoisted_55 = { class: "fs_14 text-muted d-block" }
const _hoisted_56 = { class: "fw_600" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_59 = { class: "fw_600 mb-2 d-block" }
const _hoisted_60 = ["value"]
const _hoisted_61 = { key: 2 }
const _hoisted_62 = { class: "row mb-4" }
const _hoisted_63 = { class: "col-md-3" }
const _hoisted_64 = { class: "card p-3 text-center" }
const _hoisted_65 = { class: "fs_24 fw_700" }
const _hoisted_66 = { class: "col-md-3" }
const _hoisted_67 = { class: "card p-3 text-center" }
const _hoisted_68 = { class: "fs_24 fw_700" }
const _hoisted_69 = { class: "col-md-3" }
const _hoisted_70 = { class: "card p-3 text-center" }
const _hoisted_71 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_72 = { class: "col-md-3" }
const _hoisted_73 = { class: "card p-3 text-center" }
const _hoisted_74 = { class: "fs_24 fw_700" }
const _hoisted_75 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_76 = { key: 1 }
const _hoisted_77 = {
  key: 2,
  class: "text-warning"
}
const _hoisted_78 = { key: 3 }
const _hoisted_79 = {
  key: 0,
  class: "card p-3 mb-4"
}
const _hoisted_80 = { class: "table-responsive" }
const _hoisted_81 = { class: "table table-sm mb-0" }
const _hoisted_82 = { class: "text-center" }
const _hoisted_83 = { class: "text-center" }
const _hoisted_84 = { class: "text-center" }
const _hoisted_85 = { class: "text-center" }
const _hoisted_86 = { class: "text-center" }
const _hoisted_87 = { class: "text-center" }
const _hoisted_88 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_89 = { key: 1 }
const _hoisted_90 = {
  key: 2,
  class: "text-warning"
}
const _hoisted_91 = { key: 3 }
const _hoisted_92 = {
  key: 1,
  class: "text-muted fs_14"
}
const _hoisted_93 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "fw_700" }
const _hoisted_96 = { class: "fs_14" }
const _hoisted_97 = {
  key: 0,
  class: "p-3"
}
const _hoisted_98 = {
  key: 0,
  class: "answerRow mb-3 pb-3 border-bottom"
}
const _hoisted_99 = { class: "fw_600 mb-1" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { class: "text-muted fs_14" }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = {
  key: 0,
  class: "fs_14"
}
const _hoisted_105 = {
  key: 0,
  class: "text-muted fs_14"
}
const _hoisted_106 = { key: 2 }
const _hoisted_107 = {
  key: 0,
  class: "ms-2 fs_14 text-muted"
}
const _hoisted_108 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_109 = ["href"]
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "docIcon" }, "📎", -1))
const _hoisted_111 = { class: "docName" }
const _hoisted_112 = {
  key: 2,
  class: "ms-3 mt-2"
}
const _hoisted_113 = { class: "fs_14 d-block text-muted" }
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { class: "fs_14" }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = {
  key: 0,
  class: "ms-2 fs_14 text-muted"
}
const _hoisted_118 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_119 = ["href"]
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "docIcon" }, "📎", -1))
const _hoisted_121 = { class: "docName" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-secondary me-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/due-diligence')))
          }, " ← "),
          _createVNode(_component_localized_text, {
            type: 'h1',
            localizedKey: "Provider Detail",
            text: "Provider Detail",
            class: "mb-0"
          })
        ])
      ]),
      (_ctx.activeTab === 2 && _ctx.detail.hasSurvey)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-tertiary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPdf()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Export PDF",
              text: "Export PDF"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn me-2", _ctx.activeTab === 1 ? 'btn-tertiary' : 'btn-secondary withBorder']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 1))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Profile",
                text: "Profile"
              })
            ], 2),
            (_ctx.detail.hasSurvey)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["btn me-2", _ctx.activeTab === 2 ? 'btn-tertiary' : 'btn-secondary withBorder']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 2))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Survey Results",
                    text: "Survey Results"
                  })
                ], 2))
              : _createCommentVNode("", true)
          ]),
          (_ctx.activeTab === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Status",
                        text: "Status",
                        class: "fs_14 text-muted d-block"
                      }),
                      _createElementVNode("span", {
                        class: _normalizeClass(["statusBadge mt-1", _ctx.getStatusClass(_ctx.detail.profile.status)])
                      }, _toDisplayString(_ctx.getStatusLabel(_ctx.detail.profile.status)), 3)
                    ]),
                    (_ctx.detail.profile.invitedBy)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Invited By",
                            text: "Invited By",
                            class: "fs_14 text-muted d-block"
                          }),
                          _createElementVNode("span", null, _toDisplayString(_ctx.detail.profile.invitedBy.email), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.detail.factoryDetails && _ctx.detail.factoryDetails.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Survey",
                            text: "Survey",
                            class: "fs_14 text-muted d-block"
                          }),
                          _createElementVNode("span", {
                            class: _normalizeClass(["fw_700", _ctx.submittedFactoryDetails.length === _ctx.detail.factoryDetails.length ? 'text-success' : 'text-warning'])
                          }, _toDisplayString(_ctx.submittedFactoryDetails.length) + "/" + _toDisplayString(_ctx.detail.factoryDetails.length), 3)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Current provider contact",
                    text: "Referente attuale",
                    class: "fw-bold me-2"
                  }),
                  (_ctx.detail.profile.invitationContactName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.detail.profile.invitationContactName) + " · ", 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.detail.profile.providerEmail), 1)
                ]),
                (_ctx.detail.profile.invitationContactHistory?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Provider contact change history",
                        text: "Storico sostituzioni referente",
                        class: "fw-bold d-block mb-2"
                      }),
                      _createElementVNode("table", _hoisted_14, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Date",
                                text: "Date"
                              })
                            ]),
                            _createElementVNode("th", null, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Previous provider contact",
                                text: "Referente precedente"
                              })
                            ]),
                            _createElementVNode("th", null, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "New provider contact",
                                text: "Nuovo referente"
                              })
                            ]),
                            _createElementVNode("th", null, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Changed by",
                                text: "Modificato da"
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.profile.invitationContactHistory, (change, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(change.changedAt, 'DD.MM.YYYY HH:mm')), 1),
                              _createElementVNode("td", null, _toDisplayString(change.previousEmail), 1),
                              _createElementVNode("td", null, _toDisplayString(change.contactName ? change.contactName + ' · ' : '') + _toDisplayString(change.newEmail), 1),
                              _createElementVNode("td", null, _toDisplayString(change.changedBy?.text || '-'), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Company Legal Name",
                        text: "Company Legal Name",
                        class: "fs_14 text-muted d-block"
                      }),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.detail.profile.companyLegalName || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Registered Address",
                        text: "Registered Address",
                        class: "fs_14 text-muted d-block"
                      }),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.detail.profile.registeredAddress || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Legal Form",
                        text: "Legal Form",
                        class: "fs_14 text-muted d-block"
                      }),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.detail.profile.legalForm || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Establishment Year",
                        text: "Establishment Year",
                        class: "fs_14 text-muted d-block"
                      }),
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.detail.profile.establishmentYear || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Parent Company / Group Structure",
                        text: "Parent Company / Group Structure",
                        class: "fs_14 text-muted d-block"
                      }),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.detail.profile.parentCompanyGroupStructure || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Main Activities",
                        text: "Main Activities",
                        class: "fs_14 text-muted d-block"
                      }),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.detail.profile.mainActivities || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Value Chain Position",
                        text: "Value Chain Position",
                        class: "fs_14 text-muted d-block"
                      }),
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.detail.profile.valueChainPosition || '-'), 1)
                    ])
                  ])
                ]),
                _hoisted_37,
                _createVNode(_component_localized_text, {
                  type: "h5",
                  localizedKey: "ESG Contact Person",
                  text: "ESG Contact Person",
                  class: "mb-3"
                }),
                (_ctx.detail.profile.esgContactPerson)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Name",
                            text: "Name",
                            class: "fs_14 text-muted d-block"
                          }),
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.detail.profile.esgContactPerson.name || '-'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Role",
                            text: "Role",
                            class: "fs_14 text-muted d-block"
                          }),
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.detail.profile.esgContactPerson.role || '-'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Email",
                            text: "Email",
                            class: "fs_14 text-muted d-block"
                          }),
                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.detail.profile.esgContactPerson.email || '-'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Phone",
                            text: "Phone",
                            class: "fs_14 text-muted d-block"
                          }),
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.detail.profile.esgContactPerson.phone || '-'), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.registry && _ctx.registryGroups.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_51,
                      _createVNode(_component_localized_text, {
                        type: "h5",
                        localizedKey: "Registry Data",
                        text: "Dati anagrafica",
                        class: "mb-3"
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registryGroups, (grp) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "mb-4",
                          key: grp.title
                        }, [
                          _createElementVNode("div", _hoisted_52, _toDisplayString(grp.title), 1),
                          _createElementVNode("div", _hoisted_53, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grp.fields, (f) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-md-3 col-sm-6",
                                key: f.label
                              }, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("span", _hoisted_55, _toDisplayString(f.label), 1),
                                  _createElementVNode("span", _hoisted_56, _toDisplayString(f.value), 1)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 2 && _ctx.detail.hasSurvey)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                (_ctx.detail.factoryDetails && _ctx.detail.factoryDetails.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("label", _hoisted_59, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Select Production Site",
                          text: "Select Production Site"
                        })
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        style: {"max-width":"400px"},
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedFactoryId) = $event)),
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFactoryChange()))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submittedFactoryDetails, (fd) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: fd.factoryId,
                            value: fd.factoryId
                          }, _toDisplayString(fd.name), 9, _hoisted_60))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.selectedFactoryId]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 2 && _ctx.selectedSurveyResponse)
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Gross Score",
                        text: "Gross Score",
                        class: "fs_14 text-muted d-block mb-1"
                      }),
                      _createElementVNode("span", _hoisted_65, _toDisplayString((_ctx.selectedSurveyResponse.grossScore ?? 0).toFixed(1)) + "%", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Adjusted Net Score",
                        text: "Adjusted Net Score",
                        class: "fs_14 text-muted d-block mb-1"
                      }),
                      _createElementVNode("span", _hoisted_68, _toDisplayString((_ctx.selectedSurveyResponse.adjustedNetScore ?? 0).toFixed(1)) + "%", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Risk Level",
                        text: "Risk Level",
                        class: "fs_14 text-muted d-block mb-1"
                      }),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["fs_24 fw_700", _ctx.getRiskLevelClass(_ctx.selectedSurveyResponse.riskLevel)])
                        }, _toDisplayString(_ctx.getRiskLevelLabel(_ctx.selectedSurveyResponse.riskLevel)), 3),
                        _createElementVNode("span", {
                          class: "infoIcon pointer ms-2",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showRiskLevelLegend())),
                          title: "Risk level legend"
                        }, "ⓘ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Red Flags",
                        text: "Red Flags",
                        class: "fs_14 text-muted d-block mb-1"
                      }),
                      _createElementVNode("span", _hoisted_74, [
                        (_ctx.selectedSurveyResponse.highRedFlagsCount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(_ctx.selectedSurveyResponse.highRedFlagsCount) + " High", 1))
                          : _createCommentVNode("", true),
                        (_ctx.selectedSurveyResponse.highRedFlagsCount && _ctx.selectedSurveyResponse.redFlagsCount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_76, " / "))
                          : _createCommentVNode("", true),
                        (_ctx.selectedSurveyResponse.redFlagsCount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_ctx.selectedSurveyResponse.redFlagsCount) + " Red", 1))
                          : _createCommentVNode("", true),
                        (!_ctx.selectedSurveyResponse.highRedFlagsCount && !_ctx.selectedSurveyResponse.redFlagsCount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_78, "0"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                (_ctx.selectedSurveyResponse.sectionScores.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      _createVNode(_component_localized_text, {
                        type: "h6",
                        localizedKey: "Section Scores",
                        text: "Section Scores",
                        class: "mb-3"
                      }),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("table", _hoisted_81, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Section",
                                  text: "Section"
                                })
                              ]),
                              _createElementVNode("th", _hoisted_82, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Score",
                                  text: "Score"
                                })
                              ]),
                              _createElementVNode("th", _hoisted_83, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Weight",
                                  text: "Weight"
                                })
                              ]),
                              _createElementVNode("th", _hoisted_84, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Red Flags",
                                  text: "Red Flags"
                                })
                              ])
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSurveyResponse.sectionScores, (ss) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: ss.sectionId
                              }, [
                                _createElementVNode("td", null, _toDisplayString(ss.sectionId), 1),
                                _createElementVNode("td", _hoisted_85, _toDisplayString((ss.weightedScore ?? 0).toFixed(1)) + "%", 1),
                                _createElementVNode("td", _hoisted_86, _toDisplayString(ss.maxWeight), 1),
                                _createElementVNode("td", _hoisted_87, [
                                  (ss.highRedFlagsCount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(ss.highRedFlagsCount) + "H", 1))
                                    : _createCommentVNode("", true),
                                  (ss.highRedFlagsCount && ss.redFlagsCount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_89, " / "))
                                    : _createCommentVNode("", true),
                                  (ss.redFlagsCount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(ss.redFlagsCount) + "R", 1))
                                    : _createCommentVNode("", true),
                                  (!ss.highRedFlagsCount && !ss.redFlagsCount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_91, "-"))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedSurveyResponse.submittedAt)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_92, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Submitted on",
                        text: "Submitted on"
                      }),
                      _createTextVNode(": " + _toDisplayString(_ctx.$filters.date(_ctx.selectedSurveyResponse.submittedAt, "DD.MM.YYYY HH:mm")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.surveyTemplate && _ctx.selectedSurveyResponse.answers.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                      _createVNode(_component_localized_text, {
                        type: "h5",
                        localizedKey: "Survey Answers",
                        text: "Survey Answers",
                        class: "mb-3"
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveyTemplate.sections, (section, si) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "answerSection mb-4",
                          key: section.sectionId
                        }, [
                          _createElementVNode("div", {
                            class: "sectionHeader pointer d-flex align-items-center justify-content-between p-3",
                            onClick: ($event: any) => (_ctx.toggleSection(si))
                          }, [
                            _createElementVNode("span", _hoisted_95, _toDisplayString(si + 1) + ". " + _toDisplayString(_ctx.getLocalized(section.title)), 1),
                            _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.expandedSections.includes(si) ? '▲' : '▼'), 1)
                          ], 8, _hoisted_94),
                          (_ctx.expandedSections.includes(si))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.questions, (question) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: question.questionId
                                  }, [
                                    (_ctx.isQuestionVisible(question))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                          _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.getLocalized(question.text)), 1),
                                          (question.subQuestions.length === 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                                (question.questionType === 2)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                                      _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.getAnswerValue(question.questionId, '').informationalText || '-'), 1)
                                                    ]))
                                                  : (question.questionType === 3)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.certificationOptions, (cert) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: cert.certificationId
                                                          }, [
                                                            (_ctx.isCertSelected(question.questionId, cert.certificationId))
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_104, " ✓ " + _toDisplayString(_ctx.getLocalized(cert.name)), 1))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        }), 128)),
                                                        (!_ctx.hasAnyCertSelected(question.questionId, question.certificationOptions))
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_105, "-"))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass(["answerBadge", _ctx.getAnswerBadgeClass(_ctx.getAnswerValue(question.questionId, '').response)])
                                                        }, _toDisplayString(_ctx.getAnswerValue(question.questionId, '').response || '-'), 3),
                                                        (_ctx.getAnswerValue(question.questionId, '').evidenceAvailable)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_107, " 📎 Evidence "))
                                                          : _createCommentVNode("", true),
                                                        (_ctx.getRedFlag(question.redFlagType, _ctx.getAnswerValue(question.questionId, '').response))
                                                          ? (_openBlock(), _createElementBlock("span", {
                                                              key: 1,
                                                              class: _normalizeClass(["redFlagBadge ms-2", _ctx.getRedFlag(question.redFlagType, _ctx.getAnswerValue(question.questionId, '').response)?.cssClass])
                                                            }, " ⚠ " + _toDisplayString(_ctx.getRedFlag(question.redFlagType, _ctx.getAnswerValue(question.questionId, '').response).label), 3))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.getAnswerAttachment(question.questionId, ''))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                                _createElementVNode("a", {
                                                  href: _ctx.getAnswerAttachment(question.questionId, '').publicUrl,
                                                  target: "_blank",
                                                  class: "docLink"
                                                }, [
                                                  _hoisted_110,
                                                  _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.getAnswerAttachment(question.questionId, '').originalFileName), 1)
                                                ], 8, _hoisted_109)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (question.subQuestions.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.subQuestions, (sub) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    class: "subAnswerRow mb-2",
                                                    key: sub.subQuestionId
                                                  }, [
                                                    _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.getLocalized(sub.text)), 1),
                                                    (sub.questionType === 2)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                                          _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.getAnswerValue(question.questionId, sub.subQuestionId).informationalText || '-'), 1)
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                                          _createElementVNode("span", {
                                                            class: _normalizeClass(["answerBadge small", _ctx.getAnswerBadgeClass(_ctx.getAnswerValue(question.questionId, sub.subQuestionId).response)])
                                                          }, _toDisplayString(_ctx.getAnswerValue(question.questionId, sub.subQuestionId).response || '-'), 3),
                                                          (_ctx.getAnswerValue(question.questionId, sub.subQuestionId).evidenceAvailable)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_117, " 📎 Evidence "))
                                                            : _createCommentVNode("", true),
                                                          (_ctx.getRedFlag(sub.redFlagType, _ctx.getAnswerValue(question.questionId, sub.subQuestionId).response))
                                                            ? (_openBlock(), _createElementBlock("span", {
                                                                key: 1,
                                                                class: _normalizeClass(["redFlagBadge ms-2", _ctx.getRedFlag(sub.redFlagType, _ctx.getAnswerValue(question.questionId, sub.subQuestionId).response)?.cssClass])
                                                              }, " ⚠ " + _toDisplayString(_ctx.getRedFlag(sub.redFlagType, _ctx.getAnswerValue(question.questionId, sub.subQuestionId).response).label), 3))
                                                            : _createCommentVNode("", true)
                                                        ])),
                                                    (_ctx.getAnswerAttachment(question.questionId, sub.subQuestionId))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                          _createElementVNode("a", {
                                                            href: _ctx.getAnswerAttachment(question.questionId, sub.subQuestionId).publicUrl,
                                                            target: "_blank",
                                                            class: "docLink"
                                                          }, [
                                                            _hoisted_120,
                                                            _createElementVNode("span", _hoisted_121, _toDisplayString(_ctx.getAnswerAttachment(question.questionId, sub.subQuestionId).originalFileName), 1)
                                                          ], 8, _hoisted_119)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}